/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { isNotNull } from '@common/tech-shared';
import {
  ExterneFachstelleResource,
  ExterneFachstelleService,
  ZUSTAENDIGE_STELLE_SERVICE,
  ZustaendigeStelleService,
} from '@alfa-client/zustaendige-stelle-shared';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ResourceUri, getUrl } from '@ngxp/rest';
import { Observable, tap } from 'rxjs';

@Component({
  selector: 'alfa-search-externe-fachstelle-container',
  templateUrl: './search-externe-fachstelle-container.component.html',
  providers: [{ provide: ZUSTAENDIGE_STELLE_SERVICE, useClass: ExterneFachstelleService }],
  standalone: false,
})
export class SearchExterneFachstelleContainerComponent implements OnInit, OnDestroy {
  private readonly service = inject<ZustaendigeStelleService<ExterneFachstelleResource>>(ZUSTAENDIGE_STELLE_SERVICE);

  @Input() public fieldControl: AbstractControl<ResourceUri>;

  @Output() searchResult: EventEmitter<ExterneFachstelleResource> = new EventEmitter<ExterneFachstelleResource>();

  public externeFachstelleResource$: Observable<ExterneFachstelleResource>;

  ngOnInit(): void {
    this.externeFachstelleResource$ = this.getSelectedResult();
  }

  ngOnDestroy(): void {
    this.service.clearSelectedResult();
  }

  getSelectedResult(): Observable<ExterneFachstelleResource> {
    return this.service
      .getSelectedResult()
      .pipe(tap((externeFachstelleResource: ExterneFachstelleResource) => this.handleResult(externeFachstelleResource)));
  }

  handleResult(externeFachstelleResource: ExterneFachstelleResource): void {
    if (isNotNull(externeFachstelleResource)) {
      this.searchResult.emit(externeFachstelleResource);
      this.fieldControl.patchValue(getUrl(externeFachstelleResource));
    }
  }
}
